require('angular').module('oly.common')
    .factory('serializeAsync', ['$q', require('./serializeasync')]);



// WEBPACK FOOTER //
// ./src/olycommon/serializeasync/index.js